var $25dc53e39d7a27ee$exports = {};
$25dc53e39d7a27ee$exports = {
    "removeButtonLabel": `Supprimer`,
    "removeDescription": `Appuyez sur Supprimer pour supprimer l\u{2019}\xe9tiquette.`
};


export {$25dc53e39d7a27ee$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
